export { default } from "./Product"
